var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"gourl",attrs:{"to":_vm.gourl}},[_vm._v("手动点击跳转至产品讲解视频")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }